import { FC } from 'react';

import StatPageSideBar from '@shared/components/StatPageSideBar';

import { AgencyGiftSettlementContainer } from '../containers/AgencyGiftSettlement/AgencyGiftSettlementContainer';

/**
 * 배송형 답례품 정산 페이지.
 */
export const AgencyAdminGiftSettlementDeliveryPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1 px-10 py-8">
      <h1 className="mb-6 text-2xl font-bold text-gray-900">배송형 정산</h1>
      <AgencyGiftSettlementContainer />
    </div>
  </div>
);
